// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.8.0
//   protoc               unknown
// source: cosmos/epochs/v1beta1/events.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import Long from "long";

export const protobufPackage = "cosmos.epochs.v1beta1";

/** EventEpochEnd is an event emitted when an epoch end. */
export interface EventEpochEnd {
  epochNumber: Long;
}

/** EventEpochStart is an event emitted when an epoch start. */
export interface EventEpochStart {
  epochNumber: Long;
  epochStartTime: Long;
}

function createBaseEventEpochEnd(): EventEpochEnd {
  return { epochNumber: Long.ZERO };
}

export const EventEpochEnd: MessageFns<EventEpochEnd> = {
  encode(message: EventEpochEnd, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (!message.epochNumber.equals(Long.ZERO)) {
      writer.uint32(8).int64(message.epochNumber.toString());
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EventEpochEnd {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEventEpochEnd();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.epochNumber = Long.fromString(reader.int64().toString());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EventEpochEnd {
    return { epochNumber: isSet(object.epochNumber) ? Long.fromValue(object.epochNumber) : Long.ZERO };
  },

  toJSON(message: EventEpochEnd): unknown {
    const obj: any = {};
    if (!message.epochNumber.equals(Long.ZERO)) {
      obj.epochNumber = (message.epochNumber || Long.ZERO).toString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EventEpochEnd>, I>>(base?: I): EventEpochEnd {
    return EventEpochEnd.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EventEpochEnd>, I>>(object: I): EventEpochEnd {
    const message = createBaseEventEpochEnd();
    message.epochNumber = (object.epochNumber !== undefined && object.epochNumber !== null)
      ? Long.fromValue(object.epochNumber)
      : Long.ZERO;
    return message;
  },
};

function createBaseEventEpochStart(): EventEpochStart {
  return { epochNumber: Long.ZERO, epochStartTime: Long.ZERO };
}

export const EventEpochStart: MessageFns<EventEpochStart> = {
  encode(message: EventEpochStart, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (!message.epochNumber.equals(Long.ZERO)) {
      writer.uint32(8).int64(message.epochNumber.toString());
    }
    if (!message.epochStartTime.equals(Long.ZERO)) {
      writer.uint32(16).int64(message.epochStartTime.toString());
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EventEpochStart {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEventEpochStart();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.epochNumber = Long.fromString(reader.int64().toString());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.epochStartTime = Long.fromString(reader.int64().toString());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EventEpochStart {
    return {
      epochNumber: isSet(object.epochNumber) ? Long.fromValue(object.epochNumber) : Long.ZERO,
      epochStartTime: isSet(object.epochStartTime) ? Long.fromValue(object.epochStartTime) : Long.ZERO,
    };
  },

  toJSON(message: EventEpochStart): unknown {
    const obj: any = {};
    if (!message.epochNumber.equals(Long.ZERO)) {
      obj.epochNumber = (message.epochNumber || Long.ZERO).toString();
    }
    if (!message.epochStartTime.equals(Long.ZERO)) {
      obj.epochStartTime = (message.epochStartTime || Long.ZERO).toString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EventEpochStart>, I>>(base?: I): EventEpochStart {
    return EventEpochStart.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EventEpochStart>, I>>(object: I): EventEpochStart {
    const message = createBaseEventEpochStart();
    message.epochNumber = (object.epochNumber !== undefined && object.epochNumber !== null)
      ? Long.fromValue(object.epochNumber)
      : Long.ZERO;
    message.epochStartTime = (object.epochStartTime !== undefined && object.epochStartTime !== null)
      ? Long.fromValue(object.epochStartTime)
      : Long.ZERO;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
